//These come from FreshDesk API - Search for Ticket Properties
export const CaseCategories = [
    { id: "", text: "Category" },
    { id: "Billing", text: "Billing" },
    { id: "Activations", text: "Activations" },
    { id: "Cancellations", text: "Cancellations" },
    { id: "Reconnection", text: "Reconnection" }
];

export const TicketStatus = [
    { id: 2, name: "Open" },
    { id: 3, name: "Pending" },
    { id: 4, name: "Resolved" },
    { id: 5, name: "Closed" }
];

export const Channels = [
    { id: 1, name: "Email" },
    { id: 2, name: "Online" }, //Note this is Portal in FreshDesk
    { id: 3, name: "Phone" },
    { id: 7, name: "Chat" },
    { id: 9, name: "Feedback Widget" },
    { id: 10, name: "Outbound Email" }
];

export const TicketPriority = [
    { id: 1, name: "Low" },
    { id: 2, name: "Medium" },
    { id: 3, name: "High" },
    { id: 4, name: "Urgent" }
]

export const CaseCategoryOptions = CaseCategories.filter(x => x.id !== "").map(x => {
    return { value: x.id, label: x.text }
});